"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.GobyUtil = void 0;
const bignumber_1 = require("@ethersproject/bignumber");
const coin_1 = require("./serializer/types/coin");
const coin_spend_1 = require("./serializer/types/coin_spend");
const spend_bundle_1 = require("./serializer/types/spend_bundle");
class GobyUtil {
    parseGobyCoin(coin) {
        try {
            const c = new coin_1.Coin();
            c.parentCoinInfo = coin["parent_coin_info"];
            c.puzzleHash = coin["puzzle_hash"];
            c.amount = bignumber_1.BigNumber.from(coin["amount"]);
            return c;
        }
        catch (_) {
            return null;
        }
    }
    parseGobyCoinSpend(coinSpend) {
        const cs = new coin_spend_1.CoinSpend();
        const coin = this.parseGobyCoin(coinSpend["coin"]);
        if (coin === null) {
            return null;
        }
        cs.coin = coin;
        cs.puzzleReveal = coinSpend["puzzle_reveal"];
        cs.solution = coinSpend["solution"];
        return cs;
    }
    parseGobySpendBundle(spendBundle) {
        try {
            const sb = new spend_bundle_1.SpendBundle();
            sb.coinSpends = [];
            const coinSpends = spendBundle["coin_spends"];
            for (let i = 0; i < coinSpends.length; ++i) {
                const coinSpend = this.parseGobyCoinSpend(coinSpends[i]);
                if (coinSpend === null) {
                    return null;
                }
                sb.coinSpends.push(coinSpend);
            }
            sb.aggregatedSignature = spendBundle["aggregated_signature"];
            return sb;
        }
        catch (_) {
            return null;
        }
    }
}
exports.GobyUtil = GobyUtil;
//# sourceMappingURL=goby.js.map